import { autoserialize } from 'cerialize';

export class ScheduleMeta implements IScheduleMeta {
  @autoserialize monday_zone_id?: string;
  @autoserialize tuesday_zone_id?: string;
  @autoserialize wednesday_zone_id?: string;
  @autoserialize thursday_zone_id?: string;
  @autoserialize friday_zone_id?: string;
  @autoserialize saturday_zone_id?: string;
  @autoserialize sunday_zone_id?: string;

  constructor(payload?: IScheduleMeta) {
    this.monday_zone_id = payload?.monday_zone_id;
    this.tuesday_zone_id = payload?.tuesday_zone_id;
    this.wednesday_zone_id = payload?.wednesday_zone_id;
    this.thursday_zone_id = payload?.thursday_zone_id;
    this.friday_zone_id = payload?.friday_zone_id;
    this.saturday_zone_id = payload?.saturday_zone_id;
    this.sunday_zone_id = payload?.sunday_zone_id;
  }
}

export interface IScheduleMeta {
  monday_zone_id?: string;
  tuesday_zone_id?: string;
  wednesday_zone_id?: string;
  thursday_zone_id?: string;
  friday_zone_id?: string;
  saturday_zone_id?: string;
  sunday_zone_id?: string;
}
